import CustomerReferral from '@sectionsJS/customer-referral';

/*
document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('customer-referral-main')) {
    customElements.define(
      'customer-referral-main',
      class CustomerReferralMain extends HTMLElement {
        constructor() {
          console.log('init constructor');
          new CustomerReferral();
        }
      }
    );
  }
});
*/

document.addEventListener('DOMContentLoaded', () => {
  new CustomerReferral();
});
